<template>
  <div class="layout_404_w">
    <div class="content_w d_flex flex_wrap align_item_c justify_content_c">
      <div class="title">
        糟糕！页面找不到了！
      </div>
      <div class="desc">
        <p>抱歉，您所访问的页面可能已经被劫持了！</p>
        <p>让我们去另外一个页面寻找真相吧！</p>
      </div>
      <div class="return_btn text_center">
        <span class="re_home"> <img src="@/assets/images/404_2.png" alt=""> <el-button class="re_home_btn" type="text" style="color:#62616B;font-size: 19px;" @click="$router.push('/')">返回首页</el-button>  </span>
        <span class="re_pre"> <img src="@/assets/images/404_1.png" alt=""> <el-button class="re_pre_btn" type="text" style="color:#62616B;font-size: 19px;" @click="$router.go(-2)">返回上一页</el-button>  </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.layout_404_w{
  position: relative;
  height:100%;
  background: url('~@/assets/images/404_3.jpg') 0 0/contain no-repeat;
  .content_w{
    overflow: hidden;
    position: absolute;
    width: 600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);

    .title{
      color: #302C48;
      font-size: 50px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
    .desc{
      margin: 25px 0;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    .return_btn{
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.2s;
      animation-fill-mode: forwards;
    }
    .desc,.return_btn{
      width: 385px;
      color: #62616B;
      font-size: 19px;
    }
    .re_home{
      margin: 0 30px 0 0;
    }
    .re_home_btn,.re_pre_btn{
      margin: 0 0 0 10px;
    }

    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>
